import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/web/Home.vue'

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/article/:id',
    component: () => import('../views/web/Article.vue')
  },
  {
    path: '/channel/:id',
    component: () => import('../views/web/Channel.vue')
  },
  {
    path: '/single/:id',
    component: () => import('../views/web/Single.vue')
  },
  {
    path: '/search/:keywords',
    component: () => import('../views/web/Search.vue')
  },
  {
    path: '/user',
    component: () => import('../views/user/index.vue')
  },
  {
    path: '/user/login',
    component: () => import('../views/user/login.vue')
  },
  {
    path: '/user/register',
    component: () => import('../views/user/register.vue')
  },
  {
    path: '/user/change_password',
    component: () => import('../views/user/changePassword.vue')
  },
  {
    path: '/user/profile',
    component: () => import('../views/user/profile.vue')
  },
  {
    path: '/user/article',
    component: () => import('../views/user/article.vue')
  },
  {
    path: '/user/complaint',
    component: () => import('../views/user/complaint/list.vue')
  },
  {
    path: '/user/complaint/add',
    component: () => import('../views/user/complaint/edit.vue')
  },
  {
    path: '/user/reporter',
    component: () => import('../views/user/reporter.vue')
  },
  {
    path: '/user/reporter/:id',
    component: () => import('../views/user/reporterDetail.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
